module.exports = __webpack_public_path__ + "static/media/Rejected.4baa6916.svg";